// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client'; // Importa a API de cliente
import './index.css'; // Importe seu arquivo CSS global (incluindo o Tailwind)
import App from './App'; // Importa seu componente principal

// Cria a raiz e renderiza o componente App no elemento com id 'root'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);